{
  "ForgotPassword": "Forgot your password?",
  "EmailAddress": "Email Address",
  "SendInstructions": "Send me instructions >",
  "Login": "Log In",
  "or": "or",
  "Signup": "Sign Up",
  "instead": "instead",
  "ResetPassword": "Reset Password"
}
